import { Plus, Search } from 'lucide-react';
import type { ThemeId } from '../../config/themes';
import { ThemePicker } from './ThemePicker';

type Props = {
  activeTheme: ThemeId;
  pageDescription: string;
  pageTitle: string;
  onOpenQuickAdd: () => void;
  onOpenSearch: () => void;
  onSelectTheme: (themeId: ThemeId) => void;
};

export const TopBar = ({ activeTheme, onOpenQuickAdd, onOpenSearch, onSelectTheme, pageDescription, pageTitle }: Props) => (
  <header className="topbar">
    <div className="mobile-brand">
      <img src="/icons/icon-192.png" alt="" width="32" height="32" />
      <strong>Spooky Plan</strong>
    </div>
    <div className="page-identity">
      <h1>{pageTitle}</h1>
      <p>{pageDescription}</p>
    </div>
    <div className="topbar-actions">
      <ThemePicker activeTheme={activeTheme} onSelectTheme={onSelectTheme} placement="mobile" />
      <button type="button" className="icon-button search-button" aria-label="Search planner" onClick={onOpenSearch}>
        <Search size={19} aria-hidden="true" />
      </button>
      <ThemePicker activeTheme={activeTheme} onSelectTheme={onSelectTheme} />
      <button type="button" className="primary-button topbar-add" onClick={onOpenQuickAdd}>
        <Plus size={18} aria-hidden="true" />
        <span>Quick add</span>
      </button>
    </div>
  </header>
);
